import { h } from "preact";

import IconProps from "./IconProps";

function IconCopy({ color, width, height, class: cssClass }: IconProps) {
    return (
        <svg class={cssClass} width={width} height={height} viewBox="0 0 24 24">
            <path fill={color} fill-rule="evenodd" d="M7 6h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm2-1H8a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1z"/>
        </svg>
    );
}

IconCopy.defaultProps = {
    color: "var(--teflon)",
    width: 24,
    height: 24
};

export default IconCopy;
